/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssetTypeSubsystemComponentclassResponseDto,
  CreateAssetTypeSubsystemComponentClassRequestDto,
  GetAllMappingsRes,
} from '../models/index';
import {
    AssetTypeSubsystemComponentclassResponseDtoFromJSON,
    AssetTypeSubsystemComponentclassResponseDtoToJSON,
    CreateAssetTypeSubsystemComponentClassRequestDtoFromJSON,
    CreateAssetTypeSubsystemComponentClassRequestDtoToJSON,
    GetAllMappingsResFromJSON,
    GetAllMappingsResToJSON,
} from '../models/index';

export interface AssetSubsystemComponentClassControllerFindByIdRequest {
    id: string;
}

export interface AssetSubsystemComponentClassControllerUpdateMappingRequest {
    mappingId: string;
    createAssetTypeSubsystemComponentClassRequestDto: CreateAssetTypeSubsystemComponentClassRequestDto;
}

/**
 * 
 */
export class KnowledgeBaseAssetSubsystemComponentClassMappingsApi extends runtime.BaseAPI {

    /**
     */
    async assetSubsystemComponentClassControllerFindAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAllMappingsRes>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/asset-subsystem-componentclass`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAllMappingsResFromJSON(jsonValue));
    }

    /**
     */
    async assetSubsystemComponentClassControllerFindAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAllMappingsRes> {
        const response = await this.assetSubsystemComponentClassControllerFindAllRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async assetSubsystemComponentClassControllerFindByIdRaw(requestParameters: AssetSubsystemComponentClassControllerFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetTypeSubsystemComponentclassResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling assetSubsystemComponentClassControllerFindById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/asset-subsystem-componentclass/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetTypeSubsystemComponentclassResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async assetSubsystemComponentClassControllerFindById(requestParameters: AssetSubsystemComponentClassControllerFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetTypeSubsystemComponentclassResponseDto> {
        const response = await this.assetSubsystemComponentClassControllerFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async assetSubsystemComponentClassControllerUpdateMappingRaw(requestParameters: AssetSubsystemComponentClassControllerUpdateMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['mappingId'] == null) {
            throw new runtime.RequiredError(
                'mappingId',
                'Required parameter "mappingId" was null or undefined when calling assetSubsystemComponentClassControllerUpdateMapping().'
            );
        }

        if (requestParameters['createAssetTypeSubsystemComponentClassRequestDto'] == null) {
            throw new runtime.RequiredError(
                'createAssetTypeSubsystemComponentClassRequestDto',
                'Required parameter "createAssetTypeSubsystemComponentClassRequestDto" was null or undefined when calling assetSubsystemComponentClassControllerUpdateMapping().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/asset-subsystem-componentclass/{mappingId}/componentclasses`;
        urlPath = urlPath.replace(`{${"mappingId"}}`, encodeURIComponent(String(requestParameters['mappingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateAssetTypeSubsystemComponentClassRequestDtoToJSON(requestParameters['createAssetTypeSubsystemComponentClassRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async assetSubsystemComponentClassControllerUpdateMapping(requestParameters: AssetSubsystemComponentClassControllerUpdateMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.assetSubsystemComponentClassControllerUpdateMappingRaw(requestParameters, initOverrides);
    }

}
